import { createAsyncThunk } from "@reduxjs/toolkit";
import { apiRequest, errorFormatHandler } from "../../helpers/apiHelper";
import { DropdownValue } from "../../components/misc/Dropdown";

export const getMediGroupsRaports = createAsyncThunk(
  "/raports/mediGroups",
  async (_, { rejectWithValue, dispatch }) => {
    try {
      const { data: responseData } = await apiRequest("/raportGrupaMed");
      return responseData;
    } catch (err: any) {
      console.warn("/raports/mediGroups", err);
      return rejectWithValue(errorFormatHandler(err, dispatch));
    }
  },
);

export const getProviderReceptionsRaports = createAsyncThunk(
  "/raports/getProviderReceptionsRaports",
  async (_, { rejectWithValue, dispatch }) => {
    try {
      const { data: responseData } = await apiRequest(
        "/raportReceptiiFurnizor",
      );
      return responseData;
    } catch (err: any) {
      console.warn("/raports/getProviderReceptionsRaports", err);
      return rejectWithValue(errorFormatHandler(err, dispatch));
    }
  },
);

export const getNomenclatorCelule = createAsyncThunk(
  "/raports/getNomenclatorCelule",
  async (_, { rejectWithValue, dispatch }) => {
    try {
      const { data: responseData } = await apiRequest("/getNomenclatorCelule");
      return responseData;
    } catch (err: any) {
      console.warn("/raports/getNomenclatorCelule", err);
      return rejectWithValue(errorFormatHandler(err, dispatch));
    }
  },
);

export const getUsersActivityReport = createAsyncThunk(
  "/reports/usersActivityReport",
  async (
    params: {
      page: number;
      per_page: number;
      selectedUsers: number[];
      selectedRoles: number[];
      month: number;
      year: number;
      day: number;
    },
    { rejectWithValue, dispatch },
  ) => {
    try {
      const { data: responseData } = await apiRequest(
        `/usersActivityReport`,
        "POST",
        params,
      );
      return responseData;
    } catch (err: any) {
      console.warn("/reports/usersActivityReport", err);
      return rejectWithValue(errorFormatHandler(err, dispatch));
    }
  },
);

export const getUsersExtraActivities = createAsyncThunk(
  "/reports/usersExtraActivities",
  async (
    params: {
      page: number;
      per_page: number;
      selectedUsers: number[];
      month: number;
      year: number;
    },
    { rejectWithValue, dispatch },
  ) => {
    try {
      const { data: responseData } = await apiRequest(
        `/usersExtraActivities`,
        "POST",
        params,
      );
      return responseData;
    } catch (err: any) {
      console.warn("/reports/usersExtraActivities", err);
      return rejectWithValue(errorFormatHandler(err, dispatch));
    }
  },
);

export const getReturningProductsToProviderRaports = createAsyncThunk(
  "/reports/returningProductsToProviderRaports",
  async (
    params: {
      page: number;
      per_page: number;
      user: string;
      provider: string;
      dataPV: string;
      docNrAndDate: string;
      productName: string;
      lot: string;
      tipPv: number;
    },
    { rejectWithValue, dispatch },
  ) => {
    try {
      const { data: responseData } = await apiRequest(
        `/returningProductsToProviderRaports`,
        "GET",
        params,
      );
      return responseData;
    } catch (err: any) {
      console.warn("/reports/returningProductsToProviderRaports", err);
      return rejectWithValue(errorFormatHandler(err, dispatch));
    }
  },
);

export const getDownloadReturningProductsToProviderRaport = createAsyncThunk(
  "/inventory/getDownloadReturningProductsToProviderRaport",
  async (
    {
      idRaport,
      dataPV,
      idReturPv,
    }: {
      idRaport: string | number | null;
      dataPV: string | null;
      idReturPv: string | number | null;
    },
    { rejectWithValue, dispatch },
  ) => {
    try {
      return await apiRequest(
        "/downloadReturningProductsRaport",
        "GET",
        {
          idRaport,
          dataPV,
          idReturPv,
        },
        undefined,
        {
          responseType: "blob",
          fileName: "raport-produse-returnate.pdf",
        },
      );
    } catch (err: any) {
      console.warn(
        "/inventory/getDownloadReturningProductsToProviderRaport",
        err,
      );
      return rejectWithValue(errorFormatHandler(err, dispatch));
    }
  },
);

export const postCollectionErrorsSimplified = createAsyncThunk(
  "/reports/postCollectionErrorsSimplified",
  async (
    params: {
      page: number;
      per_page: number;
      selectedUsers: number[];
      month: number;
      year: number;
      day: number;
    },
    { rejectWithValue, dispatch },
  ) => {
    try {
      const { data: responseData } = await apiRequest(
        `/collectionErrors`,
        "POST",
        params,
      );
      return responseData;
    } catch (err: any) {
      console.warn("/reports/postCollectionErrorsSimplified", err);
      return rejectWithValue(errorFormatHandler(err, dispatch));
    }
  },
);

export const postCollectionErrorsDetailed = createAsyncThunk(
  "/reports/postCollectionErrorsDetailed",
  async (
    params: {
      page: number;
      per_page: number;
      selectedUsers: number[];
      month: number;
      year: number;
      day: number;
    },
    { rejectWithValue, dispatch },
  ) => {
    try {
      const { data: responseData } = await apiRequest(
        `/collectionErrorsDetailed`,
        "POST",
        params,
      );
      return responseData;
    } catch (err: any) {
      console.warn("/reports/postCollectionErrorsDetailed", err);
      return rejectWithValue(errorFormatHandler(err, dispatch));
    }
  },
);

export const getMonthActivityWmsReports = createAsyncThunk(
  "/reports/getMonthActivityWmsReports",
  async (
    params: {
      page: number;
      per_page: number;
      selectedUsers?: number[];
      selectedRoles?: number[];
      month: number;
      year: number;
    },
    { rejectWithValue, dispatch },
  ) => {
    try {
      const { data: responseData } = await apiRequest(
        `/getMonthActivityWmsReports`,
        "POST",
        params,
      );
      return responseData;
    } catch (err: any) {
      console.warn("/reports/getMonthActivityWmsReports", err);
      return rejectWithValue(errorFormatHandler(err, dispatch));
    }
  },
);

export const getDownloadMonthActivityReports = createAsyncThunk(
  "/admin/getDownloadMonthActivityReports",
  async (
    {
      month,
      year,
    }: {
      month: number | string;
      year: number | string;
    },
    { rejectWithValue, dispatch },
  ) => {
    try {
      return await apiRequest(
        `/exportMonthActivityWmsReports/${month}/${year}`,
        "GET",
        undefined,
        undefined,
        {
          responseType: "blob",
        },
      );
    } catch (err: any) {
      console.warn("/admin/getDownloadMonthActivityReports", err);
      return rejectWithValue(errorFormatHandler(err, dispatch));
    }
  },
);

export const getDownloadPickingErrorSimplifiedReport = createAsyncThunk(
  "/inventory/collection-errors/export-csv",
  async (
    params: {
      day: string | number | null;
      month: string | number | null;
      year: string | number | null;
      selectedUsers?: DropdownValue[];
    },
    { rejectWithValue, dispatch },
  ) => {
    try {
      return await apiRequest(
        "/collection-errors/export-csv",
        "POST",
        params,
        undefined,
        {
          responseType: "blob",
        },
      );
    } catch (err: any) {
      console.warn("/inventory/collection-errors/export-csv", err);
      return rejectWithValue(errorFormatHandler(err, dispatch));
    }
  },
);

export const getDownloadPickingErrorAdvancedReport = createAsyncThunk(
  "/inventory/collection-errors-detailed/export-csv",
  async (
    params: {
      day: string | number | null;
      month: string | number | null;
      year: string | number | null;
      selectedUsers?: DropdownValue[];
    },
    { rejectWithValue, dispatch },
  ) => {
    try {
      return await apiRequest(
        "/collection-errors-detailed/export-csv",
        "POST",
        params,
        undefined,
        {
          responseType: "blob",
        },
      );
    } catch (err: any) {
      console.warn("/inventory/collection-errors-detailed/export-csv", err);
      return rejectWithValue(errorFormatHandler(err, dispatch));
    }
  },
);

export const getDownloadReturningReport = createAsyncThunk(
  "/inventory/returning-report/export-csv",
  async (
    params: {
      page?: number;
      perPage?: number;
      status: string | null;
      deliveryPoint: string | null;
    },
    { rejectWithValue, dispatch },
  ) => {
    try {
      return await apiRequest(
        "/receptii-retur/export-csv",
        "GET",
        params,
        undefined,
        {
          responseType: "blob",
        },
      );
    } catch (err: any) {
      console.warn("/inventory/returning-report/export-csv", err);
      return rejectWithValue(errorFormatHandler(err, dispatch));
    }
  },
);

export const getDownloadRapoarteReturnareFurnizor = createAsyncThunk(
  "/inventory/rapoarte-returnare-furnizor/export-csv",
  async (
    params: {
      page?: number;
      perPage?: number;
      user: string;
      provider: string;
      dataPV: string;
      docNrAndDate: string;
      productName: string;
      lot: string;
      tipPv: string;
    },
    { rejectWithValue, dispatch },
  ) => {
    try {
      return await apiRequest(
        "/rapoarte-returnare-furnizor/export-csv",
        "POST",
        params,
        undefined,
        {
          responseType: "blob",
        },
      );
    } catch (err: any) {
      console.warn("/inventory/rapoarte-returnare-furnizor/export-csv", err);
      return rejectWithValue(errorFormatHandler(err, dispatch));
    }
  },
);

export const getDownloadProductHistory = createAsyncThunk(
  "/product-history/export-csv",
  async (
    params: {
      codProdus?: string;
      lot?: string;
      dataExpirare?: string;
    },
    { rejectWithValue, dispatch },
  ) => {
    try {
      return await apiRequest(
        "/product-history/export-csv",
        "GET",
        params,
        undefined,
        {
          responseType: "blob",
        },
      );
    } catch (err: any) {
      console.warn("/inventory//product-history/export-csv", err);
      return rejectWithValue(errorFormatHandler(err, dispatch));
    }
  },
);

export const getDownloadIntrariProduse = createAsyncThunk(
  "/produse-receptionate/export-csv",
  async (
    params: {
      page?: number;
      per_page?: number;
      startDate?: string;
      endDate?: string;
      numeProdus?: string;
      numeFurnizor?: string;
      lot?: string;
      codFactura?: string;
    },
    { rejectWithValue, dispatch },
  ) => {
    try {
      return await apiRequest(
        "/produse-receptionate/export-csv",
        "POST",
        params,
        undefined,
        {
          responseType: "blob",
        },
      );
    } catch (err: any) {
      console.warn("/inventory/produse-receptionate/export-csv", err);
      return rejectWithValue(errorFormatHandler(err, dispatch));
    }
  },
);
